<template>
	<div>

		<breadcrumbs />

		<div class="os-tabs-controls">
			<ul class="nav nav-tabs upper mt-2 px-5">
				<li class="nav-item">
					<router-link :to="{ query: {  } }" class="nav-link" exact-active-class="active" exact> {{ t.betting.all }}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ query: { status: 1 } }" class="nav-link" exact-active-class="active" exact><span class="status-pill yellow smaller"></span> {{ t.betting.waiting }}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ query: { status: 2 } }" class="nav-link" exact-active-class="active" exact><span class="status-pill green smaller"></span> {{ t.betting.win }}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ query: { status: 6 } }" class="nav-link" exact-active-class="active" exact><span class="status-pill blue smaller"></span> {{ t.betting.cashout }}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ query: { status: 3 } }" class="nav-link" exact-active-class="active" exact><span class="status-pill red smaller"></span> {{ t.betting.loss }}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ query: { status: 5 } }" class="nav-link" exact-active-class="active" exact><span class="status-pill green smaller"></span> {{ t.betting.refund }}</router-link>
				</li>
				<li class="nav-item">
					<router-link :to="{ query: { status: 4 } }" class="nav-link" exact-active-class="active" exact><span class="status-pill blue smaller"></span> {{ t.betting.cancelled }}</router-link>
				</li>
			</ul>
		</div>

		<loading :active.sync="isLoading"></loading>

		<div class="content-panel-toggler">
			<i class="os-icon os-icon-grid-squares-22"></i><span>Sidebar</span>
		</div>
		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.betting.title.list }}
							</h6>
							<div class="element-box-tp">

								<div class="alert alert alert-warning" v-if="status > 200">
									<span v-if="status == 401">
										{{ t.error.access_denied_content }}
									</span>
									<span v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</span>
								</div>

								<!--------------------
                    START - Pipeline
                    -------------------->
								<div class="pipeline white" :class="betClass(bet.coupon.result)" v-if="w <= 700 && status == 200" v-for="bet in bets">
									<div class="pipeline-body">
										<div class="row p-0">
											<div class="col-6">
												<div class="listy b-b">
													<span class="label">
														#
													</span>
													{{ bet.coupon.id }}
												</div>
											</div>
											<div class="col-6">
												<div class="listy b-b">
													<span class="label">
														{{ t.betting.title.status }}
													</span>
													<template v-if="bet.coupon.result.key == 'waiting'">
														<span class="status-pill yellow smaller"></span><span>{{ t.betting[bet.coupon.result.key] }}</span>
													</template>
													<template v-if="bet.coupon.result.key == 'win' || bet.coupon.result.key == 'refund'">
														<span class="status-pill green smaller"></span><span>{{ t.betting[bet.coupon.result.key] }}</span>
													</template>
													<template v-if="bet.coupon.result.key == 'loss'">
														<span class="status-pill red smaller"></span><span>{{ t.betting[bet.coupon.result.key] }}</span>
													</template>
													<template v-if="bet.coupon.result.key == 'cancelled'">
														<span class="status-pill blue smaller"></span><span>{{ t.betting[bet.coupon.result.key] }}</span>
													</template>
												</div>
											</div>
											<div class="col-6">
												<div class="listy b-b">
													<span class="label">
														{{ t.betting.title.date }}
													</span>
														{{ bet.coupon.created_at | moment('D MMM ddd', session.timezone) | slimiter(10) }}
													<span class="smaller lighter">
														{{ bet.coupon.created_at | moment('HH:MM', session.timezone) | slimiter(10) }}
													</span>
												</div>
											</div>
											<div class="col-6">
												<div class="listy b-b">
													<span class="label">
														{{t.betting.title.payed}}
													</span>
													<span>{{ bet.coupon.amount | toMoney(bet.coupon.currency) }}</span>
												</div>
											</div>
											<div class="col-3">
												<div class="listy b-b">
													<span class="label">
														{{t.betting.title.multiplier}}
													</span>
													<span>{{ bet.coupon.multiplier}}</span>
												</div>
											</div>
											<div class="col-3">
												<div class="listy b-b">
													<span class="label">
														{{ t.betting.title.progress }}
													</span>
													{{ (bet.coupon.wait_count - bet.coupon.odd_count) }} / {{ bet.coupon.odd_count }}
												</div>
											</div>
											<div class="col-6">
												<div class="listy b-b">
													<span class="label">
														{{t.betting.title.earnings}}
													</span>
                          						<span v-if="bet.promotion"><i class="fa fa-bold"></i></span>
														{{ bet.coupon.earnings | toMoney(bet.coupon.currency)}}
												</div>
											</div>
											<div class="col-6">
												<div class="listy b-b">
													<span class="label">
														{{t.user.username}}
													</span>
													<router-link :to="{name: 'userprofile', params: {id: bet.by.uid}}"> @{{ bet.by.username }}</router-link>
												</div>
											</div>
											<div class="col-6 text-right">
												<router-link class="btn btn-outline-primary w150" id="'c_'+row.coupon.id" :to="{name: 'bets', params: {id: bet.coupon.id}, query: $route.query}">
													<i data-v-2aff8382="" class="icon-plus"></i>
													{{ bet.coupon.odd_count }}
												</router-link>
											</div>

											<div class="col-12 ">
                        <div class="listy b-b">
													<span class="label">
                            Cashout Offer
													</span>
                          	<cashoutPrice :id="bet.coupon.id"/>
                        </div>
											</div>
										</div>
									</div>
								</div>
								<!--------------------
								END - Pipeline
								-------------------->

								<table-component
										v-if="w > 700 && status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="bets"
										sort-by="coupon.id"
										sort-order="desc"
								>
									<template>
										<table-column show="coupon.id" label="#" cell-class="w150"/>
										<table-column :show="t.betting.title.status" :label="t.betting.title.status" cell-class="w150">
											<template slot-scope="row">
												<template v-if="row.coupon.result.key == 'waiting'">
													<span class="status-pill yellow smaller"></span><span>{{ t.betting[row.coupon.result.key] }}</span>
												</template>
												<template v-if="row.coupon.result.key == 'win' || row.coupon.result.key == 'refund'">
													<span class="status-pill green smaller"></span><span>{{ t.betting[row.coupon.result.key] }}</span>
												</template>
												<template v-if="row.coupon.result.key == 'loss'">
													<span class="status-pill red smaller"></span><span>{{ t.betting[row.coupon.result.key] }}</span>
												</template>
												<template v-if="row.coupon.result.key == 'cancelled' || row.coupon.result.key == 'cashout'">
													<span class="status-pill blue smaller"></span><span>{{ t.betting[row.coupon.result.key] }}</span>
												</template>
											</template>
										</table-column>
										<table-column :show="t.user.username" :label="t.user.username" cell-class="w150 text-left">
											<template slot-scope="row">
												<b-popover :target="'us_'+row.coupon.id" triggers="hover focus" placement="leftbottom">
													<div class="user-with-avatar">
														<img alt="" :src="api+'api/v1/users/get/profile_pic/'+row.by.uid">
														<span class="d-none d-xl-inline-block">{{ row.by.full_name }}</span>
													</div>
													<div class="row mt-3">
														<div class="listy b-b" v-if="row.by.is_online ">
														<span class="label">
															{{ t.betting.title.status }}
														</span>
															{{ t.user.online }}
														</div>
														<div class="listy b-b">
														<span class="label">
															{{ t.user.last_login }}
														</span>
															{{ row.by.last_login | timeAgo }}
														</div>
														<div class="listy b-b">
														<span class="label">
															{{ t.user.balance }}
														</span>
															{{ row.by.balance | toMoney(row.by.currency) }}
														</div>
													</div>
												</b-popover>
												<div class="user-with-avatar">
													<span :id="'us_'+row.coupon.id"><router-link :to="{name: 'userprofile', params: {id: row.by.uid}}"> @{{ row.by.username }}</router-link></span>
												</div>
											</template>
										</table-column>
										<table-column :show="t.betting.title.date" :label="t.betting.title.date" cell-class="w150 px-0 text-center">
											<template slot-scope="row">
												{{ row.coupon.created_at | moment('D MMM ddd', session.timezone) | slimiter(10) }}
												<span class="smaller lighter">
													{{ row.coupon.created_at | moment('HH:mm', session.timezone) | slimiter(10) }}
												</span>
											</template>
										</table-column>
										<table-column :show="t.betting.title.progress" :label="t.betting.title.progress" cell-class="w50 px-0 text-center">
											<template slot-scope="row">
												{{ (row.coupon.wait_count - row.coupon.odd_count) }} / {{ row.coupon.odd_count }}
											</template>
										</table-column>
										<table-column :show="t.betting.title.payed" :label="t.betting.title.payed" cell-class="w150 text-right">
											<template slot-scope="row">
												<span>{{ row.coupon.amount | toMoney(row.coupon.currency) }}</span>
											</template>
										</table-column>
										<table-column :show="t.betting.title.multiplier" :label="t.betting.title.multiplier" cell-class="w50 text-right">
											<template slot-scope="row">
												<span>{{ row.coupon.multiplier}}</span>
											</template>
										</table-column>
										<table-column :show="t.betting.title.earnings" :label="t.betting.title.earnings" cell-class="w150 text-right">
											<template slot-scope="row">
                       							<span v-if="row.promotion"><i v-tooltip="row.promotion.title" class="fa fa-bold pull-left pt-1 text-danger"></i></span>
												<span>{{ row.coupon.cashout_amount || row.coupon.calculated_earnings || row.coupon.earnings | toMoney(row.coupon.currency) }}</span>
											</template>
										</table-column>
										<table-column show="Cashout Offer" label="Cashout Offer" cell-class="w150 text-right">
											<template slot-scope="row">
												<span><cashoutPrice :id="row.coupon.id" /></span>
											</template>
										</table-column>
										<table-column cell-class="px-0 w50 text-right">
											<template slot-scope="row">
												<router-link class="pull-left col-12" id="'c_'+row.coupon.id" :to="{name: 'bets', params: {id: row.coupon.id}, query: $route.query}">
													+{{ row.coupon.odd_count }}
												</router-link>
											</template>
										</table-column>
										<table-column cell-class="px-0 w50 text-center">
											<template slot-scope="row">
												<span :id="'c_'+row.coupon.id" class="ml-2 pull-right col-12"><i class="icon-info"></i></span>
												<b-popover :target="'c_'+row.coupon.id" triggers="hover focus">
													<template slot="title">{{ t.betting.title.bet_details }}</template>
													<div class="row p-0">
														<div class="col-6 p-0">
															<div class="listy b-b">
																<span class="label">
																	{{ t.betting.title.bet_type }}
																</span>
																{{ t.betting.type[row.coupon.type.name] }}
																<span v-if="row.coupon.type.name == 'system'">
																({{ row.coupon.combinations }})
																</span>
															</div>
															<div class="listy b-b">
																<span class="label">
																	{{ t.betting.title.cancelled_bets }}
																</span>
																{{ row.coupon.cancel_count }}
															</div>
															<div class="listy b-b">
																<span class="label">
																	{{ t.betting.title.refunded_bets }}
																</span>
																{{ row.coupon.refund_count }}
															</div>
															<div class="listy b-b">
																<span class="label">
																	{{ t.last_update }}
																</span>
																{{ row.coupon.updated_at | timeAgo }}
															</div>
														</div>
														<div class="col-6 p-0">
															<div class="listy b-b">
																<span class="label">
																	{{ t.betting.title.losed_bets }}
																</span>
																{{ row.coupon.loss_count }}
															</div>
															<div class="listy b-b">
																<span class="label">
																	{{ t.betting.title.winning_bets }}
																</span>
																{{ row.coupon.win_count }}
															</div>
															<div class="listy b-b">
																<span class="label">
																	{{ t.betting.title.waiting_bets }}
																</span>
																{{ row.coupon.wait_count }}
															</div>
														</div>
													</div>
												</b-popover>
											</template>
										</table-column>
									</template>
								</table-component>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
						<!--END - User List -->
					</div>
				</div>
			</div>
			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>

				<div class="element-wrapper">
					<div class="element-actions actions-only">

					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
            			<filterGenerator :filter="filter"></filterGenerator>
					</div>
				</div>

				<trendWidget />
			</div>
			<!------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="umodal" v-on:close="closeBet">
			<sweet-modal-tab :title="t.betting.title.bet_details" id="tab1">
				<betDetail :betid="new Number($route.params.id)" v-if="$route.params.id" />
			</sweet-modal-tab>
			<sweet-modal-tab :title="t.navigation.transactions" id="tab2">
				<div class="text-left">
					<transactionBet :filter="{per_page: 50, dataId: [$route.params.id], type: [1,23,24,25,26,27,45]}" v-if="$route.params.id" />
				</div>
			</sweet-modal-tab>
			<sweet-modal-tab title="" id="tab3">

				<discuss :betId="$route.params.id" v-if="$route.params.id > 99999999999999999999" />

			</sweet-modal-tab>

		</sweet-modal>
	</div>
</template>

<script>
    import transactionBet from '@/components/accounting/widget/transaction'
    import { TableComponent, TableColumn } from 'vue-table-component'
    import betDetail from '@/components/user/account/betDetail'
    import trendWidget from '@/components/user/bets/widget/trends'
    import filterGenerator from '@/components/form/filter'
    import discuss from '@/components/discuss/discuss'
    import cashoutPrice from '@/components/user/cashoutPrice'

    export default {
        name: 'betList',
	    components: { 'table-component': TableComponent, 'table-column': TableColumn, betDetail, trendWidget, filterGenerator, transactionBet, discuss, cashoutPrice },
        data () {
            return {
                api: window.api,
                session: this.$root.session,
                t: this.$root.t,
                status: 0,
	            bets: null,
	            pagination: null,
                isLoading: false,
                filter: {},
                modalTheme: this.$root.modalTheme,
	              w: window.innerWidth,
                currencies: [],
                promotions: []
            }
        },
        watch: {
            '$route.params.id' (o, n) {
                if (o) {
                    this.$refs.umodal.open();
                }
            },
            '$route.query' () {
                this.fetchBets();
            },
        },
        mounted () {

            this.fetchCurrencies();
			      this.fetchResults();
            this.fetchPromotions();

            this.$watch('track', function() {
                if(this.$route.params.id > 0) {
                    this.$refs.umodal.open();
                }
            });

            this.fetchBets();

            if(this.$route.params.id > 0) {
                setTimeout(this.openBet, 1000)
            }
        },
	    methods: {
            filterNow: function() {
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            filterBets () {
                this.filter = {
                    model: {
                        page: 1,
                        id: '',
                        uid: '',
                        createdAt: '',
	                      updatedAt: '',
                        currency: [],
                        payed: [],
                        multiplier: [],
                        earnings: [],
                        lastUpdate: [],
                        createdAt: [],
	                      status: [],
                        promotions: []
                    },
                    schema: {
                        groups: [
                            {
                                legend: 'Genel',
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: 'Bet id',
                                        model: "id",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.betting.title.payed,
                                        model: "payed",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.betting.title.multiplier,
                                        model: "multiplier",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "AmountRange",
                                        label: this.t.betting.title.earnings,
                                        model: "earnings",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.user.id,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.user.username,
                                        model: "uid",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.promotions,
                                        model: "promotions",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.promotions,
                                        checklistOptions: {
                                            value: "id",
                                            name: "title"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.status,
                                        model: "status",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.results,
                                        checklistOptions: {
                                            value: "id",
                                            name: "name"
                                        }
                                    },
                                    {
                                        type: "checklist",
                                        label: this.t.finance.currency,
                                        model: "currency",
                                        multi: true,
                                        required: false,
                                        multiSelect: true,
                                        values: this.currencies,
                                        checklistOptions: {
                                            value: "id",
                                            name: "iso_code"
                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.user.created_at,
                                        model: "createdAt",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.last_update,
                                        model: "lastUpdate",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.filter.title,
                                        onSubmit: this.filterNow,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            openBet () {
                this.$refs.umodal.open()
            },
            closeBet () {
                this.$router.replace({ params: {id: null}, query: this.$route.query});
                setTimeout( () => {
                    document.body.style.overflow='auto';
                }, 600)
            },
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });


                window.scroll(0, 0);
            },
            async fetchResults () {
                this.$http.get(api+'api/v1/bet/results').then(response => {

                  this.results = response.body.result.items;
                  this.filterBets()
                }, response => {

                })
            },
            async fetchCurrencies () {
	            this.$http.get(api+'api/v1/currencies').then(response => {

		            this.currencies = response.body.result.currencies;
                    this.filterBets()
              }, response => {

              })
            },
            async fetchBets () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/bets?wb=1&noCache=1', {params:  this.$route.query })
                        .then(response => {

                            this.bets = response.body.result.bets;
                            this.pagination = response.body.pagination;
                            this.status = response.status;
                            this.isLoading = false;
                        }, response => {
                            this.status = response.status;
                            this.isLoading = false;
                        })
                }
            },
            betClass (result) {
                  if (result.key == 'waiting') {
                      return 'lined-warning';
                  }
                  if (result.key == 'cancelled') {
                      return 'lined-primary';
                  }
                    if (result.key == 'win' || result.key == 'refund') {
                  return 'lined-success';
                    }
                    if (result.key == 'loss') {
                  return 'lined-danger';
                    }
		      },
          async fetchPromotions () {
              this.$http.get(api+'api/v1/promotions?noCache=1').then(response => {
                  // get body data
                  this.promotions = response.body.promotions;
                  this.filterBets()
              }, response => {
              })
          },
	     }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.nav-link span {
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/bets/list.vue